// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunityPage: action.mostCreativePeopleCommunityPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunityPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunityPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
